import React, { FC } from 'react';
import { DomotzRtdentry } from '../../../interfaces/NetworkDevices';
import Typography from '../../typography/Typography';
import { calculateSummaryStats } from './NeworkDeviceRtd';

interface props {
  history: DomotzRtdentry[];
}

const COLORS = {
  PRIMARY: '#D0B1F2',
  MEDIAN: '#876CDD',
  MAX: '#BE7AE2',
  MIN: '#AFD8F7',
  LOSS: '#F4A9A6',
  NEUTRAL: '#E4CADD',
};

const NetworkRtdSummary: FC<props> = ({ history }) => {
  const stats = calculateSummaryStats(history);

  const StatCard = ({ title, value, unit, color }) => (
    <div
      className="bg-white dark:bg-gray-800 p-4 rounded-lg flex flex-col justify-center border border-gray-200 dark:border-gray-700 shadow-sm"
      style={{ borderLeft: `4px solid ${color}` }}
    >
      <p className="text-2xl font-semibold" style={{ color: color }}>
        {value.toFixed(1)}
        {unit}
      </p>
      <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mt-1 uppercase tracking-wide">
        {title}
      </p>
    </div>
  );
  return (
    <div className="mt-5">
      <Typography tag="h2" type="semibold" addClass={'border-b  pb-2'}>
        RTD Stats - Last 48h
      </Typography>
      <Typography tag="span" type="small">
        RTD staat voor Round-Trip Delay (ook vaak RTT of Round-Trip Time
        genoemd). Je kunt het zien als de reistijd heen en weer van een klein
        stukje informatie (een zogenaamde 'datapakket') over het netwerk (tussen
        dit device en de monitoring agent).
      </Typography>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 mb-8">
        <StatCard
          title="Avg. Median Latency"
          value={stats.overallAverageMedianLatency}
          unit="ms"
          color={COLORS.MEDIAN}
        />
        <StatCard
          title="Max Latency Spike"
          value={stats.overallMaxLatency}
          unit="ms"
          color={COLORS.MAX}
        />
        <StatCard
          title="Total Packet Loss"
          value={stats.overallPacketLoss}
          unit="%"
          color={COLORS.LOSS}
        />
        <StatCard
          title="Total Tests Run"
          value={stats.totalTests}
          unit=""
          color={COLORS.NEUTRAL}
        />
      </div>
    </div>
  );
};

export default NetworkRtdSummary;
